/**
 * 下载管理 - 调用后端统一导出列表接口
 *
 * 后端 2026-05-21 提供统一接口 `mingyang_export.export_list`,
 * 一次拉回项目管理 / 检查项记录 / 知识库三类导出任务,无需前端聚合。
 * 入参不再传 user_id(后端从登录态取),只传分页参数。
 */
import { callMingyangTask } from '../api/client'
import { DownloadModule, DownloadRecord } from './types'

interface FetchAllExportsParams {
  page?: number
  page_size?: number
}

interface ExportListResponse {
  total: number
  list: any[]
}

/** module_label → DownloadModule 兜底映射(后端没返 module 字段时用) */
const MODULE_LABEL_TO_KEY: Record<string, DownloadModule> = {
  项目管理导出: 'project',
  检查项记录导出: 'check_record',
  知识库导出: 'knowledge'
}

function pickModule(raw: any): DownloadModule {
  const m = raw?.module
  if (m === 'project' || m === 'check_record' || m === 'knowledge') return m
  const byLabel = MODULE_LABEL_TO_KEY[raw?.module_label]
  if (byLabel) return byLabel
  return 'check_record'
}

/** 后端 ExportTaskDetail → 前端统一 DownloadRecord */
function adapt(raw: any): DownloadRecord {
  const mod = pickModule(raw)
  const expId = raw.id ?? raw.export_id ?? ''
  return {
    id: `${mod}:${expId}`,
    name: raw.name || '',
    module: mod,
    status: (raw.status ?? 0) as 0 | 1 | 2,
    row_count: typeof raw.row_count === 'number' ? raw.row_count : null,
    download_url: raw.file_url || raw.download_url || '',
    error_msg: raw.error_msg || '',
    operator: raw.operator_name || raw.operator || '',
    start_time: raw.start_time || '',
    end_time: raw.end_time || ''
  }
}

export async function fetchAllExports(
  dispatch: (...args: any[]) => any,
  params: FetchAllExportsParams = {}
): Promise<DownloadRecord[]> {
  const data = await callMingyangTask<ExportListResponse>(
    dispatch,
    'mingyang_export',
    'export_list',
    {
      page: params.page || 1,
      page_size: params.page_size || 100
    }
  )

  const list = Array.isArray(data?.list) ? data.list : []
  const records = list.map(adapt)

  // 后端已按 start_time 倒序,这里兜底再排一次,防止字段缺失
  records.sort((a, b) => (a.start_time < b.start_time ? 1 : -1))
  return records
}
